export const SCRIPT_FNCLS_KEY = 'fncls'
export const SCRIPT_FNCLS_VALUE =
  'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99'
export const FRAUD_NET_CONFIG_ID = 'fconfig'
export const FRAUD_NET_SCRIPT_TYPE = 'application/json'
